import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '~/services/notification';

import api, { makeOptions } from '~/services/api';
import UserPersonalDataActions from '../ducks/users-personal-data';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));

export function* create(action) {
  try {
    const { data: post } = action;
    const { data } = yield call(
      api.post,
      '/user-personal-data',
      post,
      makeOptions(dataLocal.auth.data),
    );

    yield put(UserPersonalDataActions.createSuccess(data));

    showToastMessage({
      type: 'success',
      text: 'Dados de usuário cadastrado com sucesso',
    });
  } catch (err) {
    yield put(
      UserPersonalDataActions.createFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* show(action) {
  try {
    const { uuid } = action;
    const { data } = yield call(
      api.get,
      `/user-personal-data/${uuid}`,
      makeOptions(dataLocal.auth.data),
    );
    yield put(UserPersonalDataActions.showSuccess(data));
  } catch (err) {
    yield put(
      UserPersonalDataActions.showFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* edit(action) {
  try {
    const { data: post } = action;
    const { data } = yield call(
      api.patch,
      `/user-personal-data/${post.uuid}`,
      post,
      makeOptions(dataLocal.auth.data),
    );

    yield put(UserPersonalDataActions.editSuccess(data));
    showToastMessage({
      type: 'success',
      text: 'Informações atualizadas com sucesso',
    });
  } catch (err) {
    yield put(
      UserPersonalDataActions.editFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* destroy(action) {
  try {
    const { uuid } = action;

    const { data: response } = yield call(
      api.delete,
      `user-personal-data/${uuid}`,
      makeOptions(dataLocal.auth.data),
    );

    showToastMessage({
      type: 'success',
      text: 'Dados de usuário removido com sucesso',
    });
    yield put(UserPersonalDataActions.deleteSuccess(response));
  } catch (err) {
    yield put(
      UserPersonalDataActions.deleteFailure('Erro ao se comunicar com a API.'),
    );
  }
}
